const user ={
	state:{
		isLogin:0,

	},
	mutations:{
		changeLogin(state,data){
		    state.isLogin = data;
		},
		

	},
	actions:{
		
	}
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js